import { Component } from '@angular/core';

@Component({
    selector: 'download-svg',
    templateUrl: './download.component.svg',
})
export class DownloadSvgComponent { }
